export type ValueOf<T> = T[keyof T];
export type Nullable<T> = T | null | undefined;

export const STATUS = {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
} as const;

export const DataStatuses = {
  PENDING: 'PENDING',
  IN_APPROVAL: 'IN_APPROVAL',
  APPROVED: 'APPROVED',
  REJECTED: 'REJECTED',
} as const;

export type Status = ValueOf<typeof STATUS>;
